module.exports = __webpack_public_path__ + "img/logo-sign.60fdd330.svg";